import React from 'react';
import { AppButton } from '@/components/atoms';
import BottomBar from '@/components/organisms/Footer';

interface Props {
  onBulkPrint: () => void;
  onFormatPrint: () => void;
  onListPrint: () => void;
  isPrinting: boolean;
}

const InvoiceActionBar: React.FC<Props> = ({
  onBulkPrint,
  onFormatPrint,
  onListPrint,
  isPrinting,
}) => (
  <BottomBar
    variant="action"
    visible
    fixed
    left={
      <>
        <AppButton
          type="primary"
          onClick={onBulkPrint}
          loading={isPrinting}
          className="min-w-[100px] rounded"
        >
          印刷
        </AppButton>
        <AppButton
          type="default"
          onClick={onListPrint}
          loading={isPrinting}
          className="min-w-[100px] rounded"
        >
          一覧印刷
        </AppButton>
        <AppButton
          type="default"
          onClick={onFormatPrint}
          loading={isPrinting}
          className="min-w-[100px] rounded"
        >
          雛形印刷
        </AppButton>
      </>
    }
  />
);

export default InvoiceActionBar;
